/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  getLosses: state => {
    return state.losses;
  },
  getTotalDataRow: state => {
    return state.totalDataRow;
  },
  getTotalPrice: state => {
    return state.totalPrice;
  },
  getTotalPagePrice: state => {
    return state.totalPagePrice;
  }
}
